var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 124",
    style: {
      enableBackground: "new 0 0 136 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFFCFC;}\n\t.st1{opacity:0.7;fill:#EFFCFC;enable-background:new    ;}\n\t.st2{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#mask0_1385_3437_00000034771864677752773530000015257609701641500584_);}\n\t.st4{fill:#028383;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 50,
    y: 34.4,
    width: 40.4,
    height: 68.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 34.4,
    width: 40.4,
    height: 68.3,
    id: "mask0_1385_3437_00000034771864677752773530000015257609701641500584_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26.3,
    className: "st2",
    width: 85,
    height: 84.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.2,76c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.4-0.5-0.4-0.9c0-0.4,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.4,0.9-0.4 h15.9c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.4,0.5,0.4,0.9c0,0.4-0.1,0.6-0.4,0.9c-0.2,0.2-0.5,0.4-0.9,0.4H62.2z M58.7,65.4 c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.4-0.5-0.4-0.9c0-0.4,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.4,0.9-0.4h23c0.4,0,0.7,0.1,0.9,0.3 c0.2,0.2,0.4,0.5,0.4,0.9c0,0.4-0.1,0.6-0.4,0.9c-0.2,0.2-0.5,0.4-0.9,0.4H58.7z M55.3,102.7c-1.5,0-2.8-0.5-3.8-1.5 c-1-1-1.5-2.3-1.5-3.8V39.7c0-1.5,0.5-2.8,1.5-3.8c1-1,2.3-1.5,3.8-1.5h29.7c1.5,0,2.8,0.5,3.8,1.5c1,1,1.5,2.3,1.5,3.8v57.7 c0,1.5-0.5,2.8-1.5,3.8c-1,1-2.3,1.5-3.8,1.5H55.3z M52.5,92h35.4V45.2H52.5V92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMobileIcon);
export default __webpack_public_path__ + "static/media/loginMobileIcon.d02c731127451db017df84cce93f9ff3.svg";
export { ForwardRef as ReactComponent };